import React, { useContext } from 'react'
import { SharedCampaignContext } from '../../../../../contexts/Advertiser/SharedCampaignContext'
import { providerLogo, formatProvider } from '../../../../../utils/Helper'

export default function CampaignOverview({ timeframeVisible, defaultOverview, customOverview, startDate, endDate }) {
  const { campaign } = useContext(SharedCampaignContext)

  return (
    <div className='w-full h-full bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-lg p-4'>
      <h1 className='font-bold text-xl border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter py-2 dark:text-white'>Campaign Overview</h1>
      <div>
        {
          defaultOverview.map(section => {
            if (section.visible) {
              return (
                <div key={section.id} className='border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter'>
                  <h2 className='font-bold text-sm py-2 dark:text-white'>{section.title}</h2>
                  <p className='text-sm pb-2 dark:text-gray-400'>{section.free_text}</p>
                </div>
              )
            }
          })
        }
        {
          customOverview.map(section => {
            if (section.visible) {
              return (
                <div key={section.id} className='border-b-1 border-rb-widget-border dark:border-rb-dark-mode-lighter'>
                  <h2 className='font-bold text-sm py-2 dark:text-white'>{section.title}</h2>
                  <p className='text-sm pb-2 dark:text-gray-400'>{section.free_text}</p>
                </div>
              )
            }
          })
        }
      </div>
      {
        timeframeVisible && (
          <div>
            <h2 className='font-bold text-sm py-2 dark:text-white'>Timeframe</h2>
            <div className='px-5 py-2 flex justify-between items-center gap-2'>
              <div>
                <p className='text-xs dark:text-gray-400'>Start date</p>
                <p className='font-bold text-sm dark:text-white'>{startDate || campaign.start_date}</p>
              </div>
              <div className="flex flex-1 items-center p-2">
                <div className='h-4 w-4 border-2 border-border-primary dark:border-rb-dark-mode-lighter rounded-full bg-rb-grey dark:bg-rb-dark-mode-lighter' />
                <div className='border-t-4 border-rb-green w-full' />
                <div className='h-4 w-4 border-2 border-rb-green rounded-full bg-rb-soft-green dark:bg-rb-green/20' />
              </div>
              <div>
                <p className='text-xs dark:text-gray-400'>End date</p>
                <p className='font-bold text-sm dark:text-white'>{endDate || campaign.end_date}</p>
              </div>
            </div>
          </div>
        )
      }
      <div>
        <h2 className='font-bold text-sm py-2 dark:text-white'>Platforms</h2>
        <div className='px-5 py-2 flex items-center gap-2'>
          {Array.from(campaign.platforms).map(platform => (
            <div key={platform} className='border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-md px-2 py-1 flex items-center gap-2 w-1/5'>
              <span>{providerLogo(platform)}</span>
              <p className='dark:text-white'>{formatProvider(platform)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}